import React from "react";
import { WHATSAPP_LINK } from "@/lib/api";

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Escríbenos por WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3.5 text-white shadow-lg shadow-[#25D366]/30 transition-transform hover:-translate-y-1"
    >
      <svg viewBox="0 0 32 32" width="22" height="22" fill="currentColor" aria-hidden>
        <path d="M19.11 17.31c-.28-.14-1.66-.82-1.91-.91-.26-.09-.44-.14-.63.14-.19.28-.72.91-.88 1.09-.16.19-.32.21-.6.07-.28-.14-1.19-.44-2.27-1.4-.84-.74-1.4-1.66-1.57-1.94-.16-.28-.02-.43.12-.57.13-.12.28-.32.42-.48.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.5-.07-.14-.63-1.52-.86-2.09-.23-.55-.46-.48-.63-.49l-.53-.01c-.19 0-.5.07-.76.35-.26.28-1 1-1 2.43s1.03 2.83 1.17 3.02c.14.19 2.03 3.1 4.92 4.35.69.3 1.23.48 1.65.61.69.22 1.32.19 1.82.12.55-.08 1.66-.68 1.9-1.34.23-.66.23-1.22.16-1.34-.07-.13-.26-.19-.54-.33zM16.02 5.33h-.01c-5.9 0-10.7 4.8-10.7 10.7 0 1.89.5 3.72 1.44 5.33L5 27l5.79-1.52c1.56.85 3.32 1.3 5.22 1.3h.01c5.9 0 10.7-4.8 10.7-10.7 0-2.86-1.11-5.55-3.13-7.57a10.65 10.65 0 00-7.57-3.18zm0 19.6h-.01c-1.7 0-3.36-.46-4.81-1.32l-.35-.21-3.44.9.92-3.36-.22-.35a8.86 8.86 0 01-1.36-4.72c0-4.9 3.99-8.89 8.9-8.89 2.37 0 4.6.92 6.28 2.6a8.83 8.83 0 012.6 6.29c0 4.9-3.99 8.89-8.89 8.89z" />
      </svg>
      <span className="hidden sm:inline text-sm font-medium">Chatea con nosotros</span>
    </a>
  );
}
